import { render, staticRenderFns } from "./TicketOperateDetail.vue?vue&type=template&id=d236730c&"
import script from "./TicketOperateDetail.vue?vue&type=script&lang=js&"
export * from "./TicketOperateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports